import { render, staticRenderFns } from "./DetailPropertiesBox.vue?vue&type=template&id=46f6fa46&scoped=true&"
import script from "./DetailPropertiesBox.vue?vue&type=script&lang=js&"
export * from "./DetailPropertiesBox.vue?vue&type=script&lang=js&"
import style0 from "./DetailPropertiesBox.vue?vue&type=style&index=0&id=46f6fa46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6fa46",
  null
  
)

export default component.exports